import moment from 'moment';
import i18n from 'i18next';

export const renderTime = (time) => {
    const isHebrew = localStorage.getItem('current_language') === "he";
    let now = moment().format('X');
    let postCreated = moment(time).format('X');
    let difference = now - postCreated;

    const currentYear = moment().year();
    const currentDate = moment().date();

    if (difference < 60) {
        return {
            actualTime: '',
           text: `${i18n.t('now')}`,
        }
    }

    if (difference < 3600) {
        const minutes = Math.ceil(difference / 60);
        return {
            actualTime: minutes,
            text: `${i18n.t('m')}`,
        }
    }

    if (currentDate === moment(time).date()) {
        const differenceBetweenTime = moment().hour() - moment(time).hour();
        return {
            actualTime: differenceBetweenTime,
            text: `${differenceBetweenTime > 1 ? i18n.t('h') : i18n.t('h')}`,
        }
    }

    if (currentYear === moment(time).year()) {
        return {
            actualTime: moment(time).format('D MMM'),
            text: '',
        }
    }

    if (currentYear > moment(time).year()) {
        return {
            actualTime: moment(time).format('D MMM, YY'),
            text: '',
        }
    }
}
